<template>
	<v-container fluid>
		<div v-if="!loading">
			<!--table-->
			<!--table head-->
			<v-row class="total mt-8" no-gutters>
				<v-col v-for="item in headers"
						class="tabCell"
						:key="item">{{item}}
				</v-col>
			</v-row>
			<!--tab content-->
			<v-row v-for="team in allUsers" no-gutters :key="team.id">
				<v-col class="tabCell">{{ team.email }}</v-col>
				<v-col class="tabCell">{{ role(team) }}</v-col>
				<v-col class="tabCell">{{ team.company }}</v-col>
				<v-col class="tabCell">{{ team.gameId }}</v-col>
				<v-col class="tabCell">{{ team.currentRound }}</v-col>
				<v-col class="tabCell">{{ team.description }}</v-col>
				<v-col class="tabCell">
					<change-data :team="team"></change-data>
				</v-col>
			</v-row>	
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import ChangeData from './changeUserData.vue'
	import Loader from '../../../layouts/Loader.vue'
	export default {
		
		data (){
			return {
				headers: ['E-mail', 'Role', 'Company', 'Game id', 'Current round', 'Description', 'Action']
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			allUsers () {
				return this.$store.getters.allUsers
			}
		},
		methods: {
			
			role (team) {
				return Object.keys(team.role)[0]
			}
		},
		components: {
			ChangeData,
			Loader
		}
	}
</script>
<style>
	.smallText {
		font-size: 0.8em;
	}
	
</style>

